module.exports = __webpack_public_path__ + "img/u656.191df76d.jpg";